'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, Route, Redirect } from 'react-router-dom';
import { MYSQL, HOLLOW } from 'DesignData/enums/AssetSources';
import { CODE, JSLINT, NONE } from 'DesignData/enums/settings/Categories';
import { LAYOUT, LAYOUT_SOURCE, TEMPLATE, CUSTOM_WIDGET, GLOBAL_WIDGET, NONE as DESIGN_ASSET_TYPE_NONE, RAW_ASSET, FOLDER, SETTINGS, WELCOME, GETTING_STARTED } from 'DesignData/enums/DesignAssetTypes';
import Settings from 'DesignManagerIde/containers/settings/Settings';
import GeneralSettings from 'DesignManagerIde/containers/settings/General';
import CodeSettings from 'DesignManagerIde/containers/settings/Code';
import JavaScriptLinterSettings from 'DesignManagerIde/containers/settings/JavaScriptLinter';
import FileDependents from 'DesignManagerIde/containers/FileDependents';
import FileRevisions from 'DesignManagerIde/containers/FileRevisions';
import { LayoutEditor, LayoutSourceEditor, CodeEditorById, CodeEditorByPath, CustomWidgetEditorById, CustomWidgetEditorByPath, GlobalWidgetEditor, EmptyState, NotFound, Welcome, RawAssetEditorById, RawAssetEditorByPath, FolderEditor, GettingStarted } from './AsyncRouteContainers';
import RoutingWrapper from './RoutingWrapper';
const DEPENDENTS_ROUTE = 'dependents';
const REVISIONS_ROUTE = 'revisions/:revisionId';
const NOT_FOUND_ROUTE = 'not-found/:assetType';

const Routes = () => {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/templates/:assetId/${DEPENDENTS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: LAYOUT,
        MainComponent: LayoutEditor,
        FinderComponent: FileDependents
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/templates/:assetId/revisions`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: LAYOUT,
        MainComponent: LayoutEditor,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/templates/:assetId/${REVISIONS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: LAYOUT,
        MainComponent: LayoutEditor,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/templates/:assetId/source`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: LAYOUT_SOURCE,
        MainComponent: LayoutSourceEditor,
        isLayoutSource: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/templates/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: LAYOUT,
        MainComponent: LayoutEditor,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/code/:assetId/${DEPENDENTS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: TEMPLATE,
        attemptToShowCompiledOutput: true,
        MainComponent: CodeEditorById,
        FinderComponent: FileDependents,
        handleOnChange: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/code/:assetId/revisions`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: TEMPLATE,
        attemptToShowCompiledOutput: true,
        MainComponent: CodeEditorById,
        FinderComponent: FileRevisions,
        handleOnChange: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/code/:assetId/${REVISIONS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: TEMPLATE,
        attemptToShowCompiledOutput: true,
        MainComponent: CodeEditorById,
        FinderComponent: FileRevisions,
        handleOnChange: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/code/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: TEMPLATE,
        attemptToShowCompiledOutput: true,
        MainComponent: CodeEditorById,
        handleOnLeave: true,
        handleOnChange: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/code/p/*",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        byPath: true,
        assetSource: HOLLOW,
        assetType: TEMPLATE,
        MainComponent: CodeEditorByPath,
        handleOnChange: true,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/revisions/global-content`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/${REVISIONS_ROUTE}/global-content`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/global-content`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById
      }))
    }), /*#__PURE__*/_jsx(Redirect, {
      from: `/custom-modules/:assetId/global-content`,
      to: `/modules/:assetId/global-content`
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/${DEPENDENTS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        FinderComponent: FileDependents
      }))
    }), /*#__PURE__*/_jsx(Redirect, {
      from: `/custom-modules/:assetId/${DEPENDENTS_ROUTE}`,
      to: `/modules/:assetId/${DEPENDENTS_ROUTE}`
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/revisions`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/modules/:assetId/${REVISIONS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Redirect, {
      from: `/custom-modules/:assetId/revisions`,
      to: `/modules/:assetId/revisions`
    }), /*#__PURE__*/_jsx(Redirect, {
      from: `/custom-modules/:assetId/${REVISIONS_ROUTE}`,
      to: `/modules/:assetId/${REVISIONS_ROUTE}`
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/modules/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorById,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Redirect, {
      from: "/custom-modules/:assetId",
      to: "/modules/:assetId"
    }), /*#__PURE__*/_jsx(Route, {
      path: "/modules/p/*",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        byPath: true,
        assetSource: HOLLOW,
        assetType: CUSTOM_WIDGET,
        MainComponent: CustomWidgetEditorByPath,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/global-modules/:assetId/${DEPENDENTS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: GLOBAL_WIDGET,
        MainComponent: GlobalWidgetEditor,
        FinderComponent: FileDependents
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/global-modules/:assetId/revisions`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: GLOBAL_WIDGET,
        MainComponent: GlobalWidgetEditor,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/global-modules/:assetId/${REVISIONS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: GLOBAL_WIDGET,
        MainComponent: GlobalWidgetEditor,
        FinderComponent: FileRevisions
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/global-modules/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: GLOBAL_WIDGET,
        MainComponent: GlobalWidgetEditor,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/file/:assetId/revisions`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: RAW_ASSET,
        MainComponent: RawAssetEditorById,
        FinderComponent: FileRevisions,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/file/:assetId/${REVISIONS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: RAW_ASSET,
        MainComponent: RawAssetEditorById,
        FinderComponent: FileRevisions,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: `/file/:assetId/${DEPENDENTS_ROUTE}`,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: RAW_ASSET,
        MainComponent: RawAssetEditorById,
        FinderComponent: FileDependents
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/file/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: RAW_ASSET,
        MainComponent: RawAssetEditorById,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/file/p/*",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        byPath: true,
        assetSource: HOLLOW,
        assetType: RAW_ASSET,
        MainComponent: RawAssetEditorByPath,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/folder/:assetId",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: FOLDER,
        MainComponent: FolderEditor,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/settings/code",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: SETTINGS,
        settingsCategory: CODE,
        MainComponent: Settings,
        SettingsEditor: CodeSettings,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/settings/javascript-linter",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: SETTINGS,
        settingsCategory: JSLINT,
        MainComponent: Settings,
        SettingsEditor: JavaScriptLinterSettings,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/settings",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: SETTINGS,
        settingsCategory: NONE,
        MainComponent: Settings,
        SettingsEditor: GeneralSettings,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/welcome",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetSource: MYSQL,
        assetType: WELCOME,
        MainComponent: Welcome,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/getting-started",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: GETTING_STARTED,
        MainComponent: GettingStarted,
        handleOnLeave: true
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: NOT_FOUND_ROUTE,
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: DESIGN_ASSET_TYPE_NONE,
        MainComponent: NotFound
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        isEmptyState: true,
        MainComponent: EmptyState
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "*",
      render: props => /*#__PURE__*/_jsx(RoutingWrapper, Object.assign({}, props, {
        assetType: DESIGN_ASSET_TYPE_NONE,
        MainComponent: NotFound
      }))
    })]
  });
};

export default Routes;